<script>
export default {
	name: "FlatBadge",
	props: {
		value: {
			type: String,
		},
		color: {
			type: String,
			default: 'gray',
			validate(value) {
				return Object.keys(this.colorClasses).includes(value);
			}
		},
		pill: Boolean,
		small: Boolean,
	},
	data() {
		return {
			colorClasses: {
				gray: 'bg-gray-100 text-gray-600',
				red: 'bg-red-100 text-red-700',
				yellow: 'bg-yellow-100 text-yellow-800',
				green: 'bg-green-100 text-green-700',
				blue: 'bg-blue-100 text-blue-700',
				indigo: 'bg-indigo-100 text-indigo-700',
				purple: 'bg-purple-100 text-purple-700',
				pink: 'bg-pink-100 text-pink-700',
			}
		}
	},
}
</script>

<template>
	<span :class="[
				colorClasses[color],
				pill ? 'rounded-full' : 'rounded-md',
				small ? 'px-1.5 py-0.5' : 'px-2 py-1',
				'inline-flex items-center text-xs font-medium'
			]">
		<slot>{{ value }}</slot>
	</span>
</template>

<style scoped>

</style>